var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{class:[_vm.style.buttonTransparent],attrs:{"disabled":_vm.disabled,"size":_vm.size},on:{"click":_vm.handlerOnClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }